import { defineStore } from 'pinia'
import { type ComputedRef, ref, watchEffect } from 'vue'
import type { ScheduleType } from './type.ts'
import { useLoadSchedule } from '@/entities/Schedule/Main/model/api.ts'
import { cloneDeep } from 'lodash'

export const useSchedule = defineStore('schedule', () => {
  const data = ref<ScheduleType | null>(null)
  const list = ref<any[]>([])

  /**
   * Функция загрузки данных
   */
  const loadData = (scheduleId: ComputedRef<number | string>) => {
    const result = useLoadSchedule(scheduleId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = result.data.value.data
        list.value = parseJson(
          cloneDeep(result.data.value.data.json || {}),
          result.data.value.data.output_count,
        )
      }
    })
  }

  /**
   * Функция парсинга данных расписания
   * @param value
   * @param outputs
   */
  const parseJson = (value: any, outputs: number) => {
    const items: any = {}

    Object.values(value).forEach((item: any) => {
      const month = item.m
      const day = item.d

      items[month] = items[month] || {}
      items[month][day] = items[month][day] || {}

      for (let i = 0; i < outputs; i++) {
        const timeKey = i.toString()

        if (item[timeKey]) {
          items[month][day][timeKey] = items[month][day][timeKey] || []
          for (let index in item[timeKey]) {
            items[month][day][timeKey].push(item[timeKey][index])
          }
        }
      }
    })

    return items
  }

  /**
   * Функция обратной сборки данных расписания
   * @param value
   */
  const createJson = (value: any) => {
    const jsonRes = {}

    let dayIndex = 0

    for (let month in value) {
      for (let day in value[month]) {
        jsonRes[dayIndex] = {
          m: month,
          d: day,
        }

        for (let contactor in value[month][day]) {
          const contactorObj = value[month][day][contactor]

          if (!Object.keys(contactorObj).length) continue

          contactorObj.sort((a: any[], b: any[]) => {
            const aSum = Number(a[0]) * 60 + Number(a[1])
            const bSum = Number(b[0]) * 60 + Number(b[1])

            return aSum - bSum
          })

          jsonRes[dayIndex][contactor] = {}

          for (const index in contactorObj) {
            jsonRes[dayIndex][contactor][index] = contactorObj[index]
          }
        }

        dayIndex++
      }
    }

    return jsonRes
  }

  return {
    data,
    list,

    loadData,
    createJson,
  }
})
